import moment from "moment-timezone";
import Const from "./constant";

export const formatUIDate = (date) => {
  return date ? moment(date).format("MMM D, YYYY") : "-";
};

export const formatTimeWithIST = (time) => {
  if (!time) return "-";
  return moment.tz(time, "HH:mm:ss", "Asia/Kolkata").format("h:mm A [IST]");
};

export const getFormattedDate = (dateObj, format = Const.DATE_TIME_FORMATS.DATE_FULL_MONTH) => {
  dateObj = dateObj?.[0];
  if (!dateObj) {
    return "";
  }
  return moment(dateObj).format(format);
};

export const getFormattedDateforAPI = (dateObj) => {
  return getFormattedDate(dateObj, Const.DATE_TIME_FORMATS.DATE_API);
};

export const getFormattedTimeforAPI = (date_) => {
  if (!date_) return null;
  const date = new Date(date_);
  return moment(date).format("HH:mm:ss");
};

export const getDateFromValue = (value = "") => {
  return value ? [moment(value).toDate()] : [];
};

export const convertTo24Hour = (timeStr) => {
  if (!timeStr) return "";

  const [time, modifier] = timeStr.trim().split(" ");
  const [hoursStr, minutes] = time.split(":");
  let hours = Number(hoursStr);

  if (modifier === "PM" && hours < 12) {
    hours += 12;
  }
  if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:00`;
};
